import React, { useState } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import DeleteOutline from '@mui/icons-material/DeleteOutline'
import { TABLE_ACTION_ICON_BUTTON_SX } from './tableActionIconButtonSx'
import { ConfirmDialog } from '../confirm'

export type DeleteButtonProps = {
  onConfirm?: () => void | Promise<void>
  onClick?: () => void
  hidden?: boolean
  tooltip?: string
  /** Nội dung xác nhận trong modal. */
  confirmTitle?: string
  /** Tiêu đề modal. */
  confirmDialogTitle?: string
  disabled?: boolean
}

const DeleteButton: React.FC<DeleteButtonProps> = ({
  onConfirm,
  onClick,
  hidden = false,
  tooltip = 'Xóa',
  confirmTitle = 'Bạn chắc chắn muốn xóa?',
  confirmDialogTitle = 'Xác nhận xóa',
  disabled = false,
}) => {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  if (hidden) return null

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (disabled) return
    if (onClick) {
      onClick()
      return
    }
    if (onConfirm) setOpen(true)
  }

  const handleConfirm = async () => {
    if (!onConfirm || loading) return
    try {
      setLoading(true)
      await onConfirm()
      setOpen(false)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Tooltip title={tooltip}>
        <span>
          <IconButton
            size="small"
            onClick={handleClick}
            disabled={disabled}
            color="error"
            aria-label={tooltip}
            sx={TABLE_ACTION_ICON_BUTTON_SX}
          >
            <DeleteOutline />
          </IconButton>
        </span>
      </Tooltip>

      {onConfirm && !onClick ? (
        <ConfirmDialog
          open={open}
          onClose={() => {
            if (!loading) setOpen(false)
          }}
          onConfirm={() => void handleConfirm()}
          loading={loading}
          closeOnConfirm={false}
          intent="error"
          title={confirmDialogTitle}
          message={confirmTitle}
          confirmText="Xóa"
          cancelText="Hủy"
          maxWidth="xs"
        />
      ) : null}
    </>
  )
}

export default DeleteButton
